import { SnCitizenIncidentDetails } from '@lib/api/entities';
import { FsAdvancedMarker, GoogleMap } from '@lib/geo/google/map';

export interface ICitizenMarker<T = any> {
  id: string;
  addTo(map: GoogleMap): void;
  getMarker(): google.maps.marker.AdvancedMarkerElement;
  remove(): void;
  update(incident: T): void;
  incident?: T;
}

export class FsCitizenIncidentMarker
  extends FsAdvancedMarker
  implements ICitizenMarker<SnCitizenIncidentDetails>
{
  public readonly id: string;

  private _incident: SnCitizenIncidentDetails | null = null;

  constructor(public incident: SnCitizenIncidentDetails) {
    super(
      {
        position: new google.maps.LatLng(
          incident?.geoLocation?.latitude,
          incident?.geoLocation?.longitude,
        ),
        title: incident.title,
        content: document.createElement('div'),
        collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
      },
      '.fs__advanced-marker-expand',
    );
    this.id = incident.id;
    this.incident = incident;
    this.update(incident);
  }

  public update(incident: SnCitizenIncidentDetails): void {
    /** Checks if the newly fetched incident is different from the last fetched incident. */
    const changeDetected: boolean =
      this._incident &&
      (this._incident?.videos.length !== incident.videos.length ||
        this._incident?.title !== incident.title ||
        this._incident?.videos.some((n) => n.hlsDone) !== incident.videos.some((n) => n.hlsDone));
    /** If the incident is not set or the incident has changed, update the marker content. */
    if (!this._incident || changeDetected) {
      const content: HTMLDivElement = this.getMarker().content as HTMLDivElement;
      content.innerHTML = this._getIcon(incident);
      if (incident.videos.length > 1)
        this.createBadgeWithCustomText(incident.videos.length.toString());
      else this.removeBadgeWithCustomText();
      this._incident = incident;
    }
  }

  private _getIcon(incident: SnCitizenIncidentDetails): string {
    const isLive = incident?.videos?.some((stream) => !stream.hlsDone);
    if (isLive) {
      return this._livePulsatingCameraIcon();
    } else {
      return '<img class="fs__citizen-camera-icon" src="/assets/fusus-icons/PNG/Icon_Citizen.png"/>';
    }
  }

  private _livePulsatingCameraIcon(): string {
    return `
    <div class="fs__axon-recording-status">
      <img class="fs__citizen-camera-icon" src="/assets/fusus-icons/PNG/Icon_Citizen.png"/>
    </div>
    `;
  }
}
